var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CriterionSelectorDialog", {
        attrs: { viewModel: _vm.criterionSelectorDialog },
        on: { "confirm-selection": _vm.handleSetCriterion },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _vm.initialized
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        staticClass: "text-dark",
                        on: { click: _vm.handleBack },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Create weighted score")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "button",
                      {
                        class: _vm.hasChanges
                          ? "btn btn-warning"
                          : "btn btn-outline-secondary",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: {
                          type: "submit",
                          disabled: _vm.isSaving,
                          form: "create-weighted-score-form",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.saveButtonText) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", { staticClass: "mb-5" }),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { id: "create-weighted-score-form" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSave.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.name,
                          expression: "name",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        required: "",
                        maxlength: "100",
                        minlength: "2",
                      },
                      domProps: { value: _vm.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.name = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error" }, [
                      _vm._v(_vm._s(_vm.nameError)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Description:")]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.description,
                          expression: "description",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.description },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.description = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Weights set:")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.weightsSetId,
                            expression: "weightsSetId",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.weightsSetId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("Default"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.weightsSets, function (ws) {
                          return _c(
                            "option",
                            { domProps: { value: ws.CriteriaWeightsSetId } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(ws.Name) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Criterion:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        staticClass: "form-control pointer bg-white",
                        attrs: { type: "text", readonly: "" },
                        domProps: { value: _vm.criterionLabel },
                        on: { click: _vm.handleShowCriterionSelector },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.handleShowCriterionSelector },
                          },
                          [_c("i", { staticClass: "fa-solid fa-ellipsis" })]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("label", [
      _vm._v("Name: "),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }